module.exports = __webpack_public_path__ + "assets/img/hero_1.d556777f.png";